/* ═══════════════════════════════════════════════════════
   MATITE PERSONALIZZATE — CONFIGURATORE
   Usa window.MATITE_CFG se presente; altrimenti parte con valori demo.
═══════════════════════════════════════════════════════ */
(function(){
'use strict';

function boot(){
const CFG = window.MATITE_CFG || {};
const root = document.getElementById('preview-matite-root') || document;
const canvas = root.querySelector('#pmCanvas') || document.getElementById('previewCanvas');
if (!canvas) return;
const ctx = canvas.getContext('2d');
const CW = canvas.width, CH = canvas.height;

const COLORS = CFG.colors || [
  { name:'Azzurro', hex:'#4A90E2' },
  { name:'Viola', hex:'#8E5CF7' },
  { name:'Fucsia', hex:'#E256C6' },
  { name:'Blu', hex:'#1F3A93' },
  { name:'Verde', hex:'#3FA34D' },
  { name:'Giallo', hex:'#F4D01E' },
  { name:'Rosso', hex:'#D83A34' },
  { name:'Arancione', hex:'#EC9F20' },
  { name:'Rosa', hex:'#E889A9' }
];
const PRICES = normalizePrices(CFG.prices);
const QUANTITIES = [
  { id:'set6', label:'Set da 6' },
  { id:'set12', label:'Set da 12' },
  { id:'set24', label:'Set da 24' }
];
const MIXES = CFG.mixes || [];
const NAME_POS = CFG.namePos || { cx:53.7, cy:59.3, w:69.2, h:12, rot:0 };
const MIX_NAME_POS = loadMixNamePos();
const SCAD = {
  contorno: 1.6,
  altezzaLettere: 13,
  diametroMatita: 8,
  gioco: 0.5,
  rilievo: 1.5,
  spessoreTesto: 14
};

const state = {
  name: CFG.defaultName || 'Leonardo',
  colorMode: 'solid',
  color: COLORS[0],
  mix: null,
  qty: 'set6',
  busy: false
};

const photo = new Image();
photo.crossOrigin = 'anonymous';
photo.onload = function(){ render(); hideLoading(); };
photo.onerror = function(){ renderFallback(); hideLoading(); };
photo.src = imageForCurrentSelection();

function $(id){ return root.querySelector('#'+id) || document.getElementById(id); }
function formatName(value){
  const clean = (value || '').trim().replace(/\s+/g, ' ');
  if (!clean) return '';
  return clean.split(' ').map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()).join(' ');
}
function hideLoading(){
  const l = $('pmLoading') || $('previewLoading');
  if (l) l.classList.add('hidden');
}
function normalizePrices(prices){
  if (!prices || !prices.regular){
    return {
      regular: {
        set6: prices && prices.set6 ? prices.set6 : '€5,90',
        set12: prices && prices.set12 ? prices.set12 : '€8,90',
        set24: prices && prices.set24 ? prices.set24 : '€14,90'
      },
      vibe: { set6:'€6,90', set12:'€9,90', set24:'€16,90' }
    };
  }
  return prices;
}
function isMixSelected(){
  return state.colorMode === 'mix' && state.mix;
}
function priceText(){
  const group = isMixSelected() ? PRICES.vibe : PRICES.regular;
  return (group && group[state.qty]) || '';
}
function currentColorName(){
  return isMixSelected() ? state.mix.name : state.color.name;
}
function imageForCurrentSelection(){
  if (isMixSelected() && CFG.images && CFG.images[state.mix.imageKey]){
    return CFG.images[state.mix.imageKey];
  }
  return (CFG.images && CFG.images.default) || CFG.image || 'assets/matite-esempio.jpg';
}
function reloadPhoto(){
  const next = imageForCurrentSelection();
  if (!next || photo.src === next) return;
  const l = $('pmLoading') || $('previewLoading');
  if (l) l.classList.remove('hidden');
  photo.src = next;
}
function roundedRect(c, x, y, w, h, r){
  const rr = Math.min(r, w/2, h/2);
  c.beginPath();
  c.moveTo(x+rr, y);
  c.lineTo(x+w-rr, y);
  c.quadraticCurveTo(x+w, y, x+w, y+rr);
  c.lineTo(x+w, y+h-rr);
  c.quadraticCurveTo(x+w, y+h, x+w-rr, y+h);
  c.lineTo(x+rr, y+h);
  c.quadraticCurveTo(x, y+h, x, y+h-rr);
  c.lineTo(x, y+rr);
  c.quadraticCurveTo(x, y, x+rr, y);
  c.closePath();
}
function drawCoverImage(){
  ctx.fillStyle = '#c9c3ad';
  ctx.fillRect(0,0,CW,CH);
  if (!photo.complete || !photo.naturalWidth) return;
  if (CFG.imageCrop){
    const scale = CFG.imageCrop.scale || 1;
    const focusX = CFG.imageCrop.x == null ? .5 : CFG.imageCrop.x;
    const focusY = CFG.imageCrop.y == null ? .5 : CFG.imageCrop.y;
    const sw = photo.naturalWidth / scale;
    const sh = photo.naturalHeight / scale;
    const sx = Math.max(0, Math.min(photo.naturalWidth - sw, photo.naturalWidth * focusX - sw / 2));
    const sy = Math.max(0, Math.min(photo.naturalHeight - sh, photo.naturalHeight * focusY - sh / 2));
    ctx.drawImage(photo, sx, sy, sw, sh, 0, 0, CW, CH);
    return;
  }
  const srcRatio = photo.naturalWidth / photo.naturalHeight;
  const dstRatio = CW / CH;
  let sw = photo.naturalWidth, sh = photo.naturalHeight, sx = 0, sy = 0;
  if (srcRatio > dstRatio){
    sw = sh * dstRatio;
    sx = (photo.naturalWidth - sw) / 2;
  } else {
    sh = sw / dstRatio;
    sy = (photo.naturalHeight - sh) / 2;
  }
  ctx.drawImage(photo, sx, sy, sw, sh, 0, 0, CW, CH);
}
function fitTextSize(text, maxWidth, maxHeight){
  let lo = 12, hi = 120, best = 12;
  for (let i=0;i<22;i++){
    const mid = (lo+hi)/2;
    ctx.font = `800 ${mid}px "Arial Rounded MT Bold", Arial, sans-serif`;
    const m = ctx.measureText(text);
    const h = (m.actualBoundingBoxAscent || mid*.75) + (m.actualBoundingBoxDescent || mid*.25);
    if (m.width <= maxWidth && h <= maxHeight){ best = mid; lo = mid; }
    else hi = mid;
  }
  return best;
}
function drawNamePlate(){
  if (isMixSelected()){
    drawMixedNamePlates();
    return;
  }
  drawSingleNamePlate({
    text: formatName(state.name) || 'Nome',
    cx: NAME_POS.cx,
    cy: NAME_POS.cy,
    w: NAME_POS.w,
    h: NAME_POS.h,
    rot: NAME_POS.rot,
    plateHex: state.color.hex,
    textHex: '#FFFFFF'
  });
}
function drawMixedNamePlates(){
  const text = formatName(state.name) || 'Nome';
  const colors = state.mix.colors || [];
  const positions = mixPositions();
  colors.slice(0, 4).forEach((col, i) => {
    const pos = positions[i] || { cx:NAME_POS.cx, cy:NAME_POS.cy };
    drawSingleNamePlate({
      text,
      cx: pos.cx,
      cy: pos.cy,
      w: NAME_POS.w * .62,
      h: NAME_POS.h * .72,
      rot: 0,
      plateHex: col.hex,
      textHex: textColorForMixPlate(col)
    });
  });
}
function mixPositions(){
  const fallback = [
    { cx:47, cy:35 },
    { cx:61, cy:51 },
    { cx:47, cy:67 },
    { cx:61, cy:83 }
  ];
  const key = state.mix && state.mix.imageKey;
  const positions = MIX_NAME_POS && key ? MIX_NAME_POS[key] : null;
  if (!Array.isArray(positions) || !positions.length) return fallback;
  return positions.map((pos, i) => ({
    cx: Number(pos.cx == null ? fallback[i].cx : pos.cx),
    cy: Number(pos.cy == null ? fallback[i].cy : pos.cy)
  }));
}
function loadMixNamePos(){
  const base = JSON.parse(JSON.stringify(CFG.mixNamePos || {
    girlVibe: [{ cx:47, cy:35 }, { cx:61, cy:51 }, { cx:47, cy:67 }, { cx:61, cy:83 }],
    boyVibe: [{ cx:47, cy:35 }, { cx:61, cy:51 }, { cx:47, cy:67 }, { cx:61, cy:83 }]
  }));
  try{
    const saved = JSON.parse(localStorage.getItem('pmMixNamePos') || '{}');
    ['girlVibe','boyVibe'].forEach(key => {
      if (Array.isArray(saved[key])) base[key] = saved[key];
    });
  }catch(e){}
  return base;
}
function textColorForMixPlate(col){
  const hex = (col.hex || '').toUpperCase();
  if (state.mix.name === 'Girl Vibe' && (hex === '#FFFFFF' || hex === '#FFF')){
    return state.mix.textHex || '#E889A9';
  }
  return '#FFFFFF';
}
function drawSingleNamePlate(opts){
  const text = opts.text;
  const w = CW * opts.w / 100;
  const h = CH * opts.h / 100;
  const rot = opts.rot * Math.PI / 180;
  const sideColor = darken(opts.plateHex, opts.plateHex === '#FFFFFF' ? .14 : .32);
  const size = fitTextSize(text, w * .74, h * .64);
  const mask = makePlateMask(text, size, w, h);
  ctx.save();
  ctx.translate(CW * opts.cx / 100, CH * opts.cy / 100);
  ctx.rotate(rot);

  ctx.save();
  ctx.globalAlpha = .30;
  ctx.filter = 'blur(7px)';
  fillMask(mask, '#000', 9, 14, 1);
  ctx.restore();

  for (let i=9;i>=1;i--){
    fillMask(mask, sideColor, i*.7, i*.95, .96);
  }

  ctx.drawImage(materialFill(mask, opts.plateHex), mask.x, mask.y);
  drawMaterialTexture(mask);

  ctx.font = `800 ${size}px "Arial Rounded MT Bold", Arial, sans-serif`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.lineJoin = 'round';
  ctx.shadowColor = 'rgba(0,0,0,.32)';
  ctx.shadowBlur = 3;
  ctx.shadowOffsetX = 2;
  ctx.shadowOffsetY = 3;
  ctx.lineWidth = Math.max(4, size * .09);
  ctx.strokeStyle = 'rgba(210,196,190,.88)';
  ctx.strokeText(text, 0, -size*.02);
  ctx.shadowColor = 'rgba(255,255,255,.35)';
  ctx.shadowBlur = 1;
  ctx.shadowOffsetX = -1;
  ctx.shadowOffsetY = -1;
  ctx.fillStyle = opts.textHex || '#FFFFFF';
  ctx.fillText(text, 0, -size*.02);
  ctx.restore();
}
function makePlateMask(text, fontSize, w, h){
  const pad = Math.max(80, fontSize * .9);
  const mc = document.createElement('canvas');
  mc.width = Math.ceil(w + pad * 2);
  mc.height = Math.ceil(h + pad * 2);
  const m = mc.getContext('2d');
  const ox = mc.width / 2;
  const oy = mc.height / 2;
  m.translate(ox, oy);
  m.fillStyle = '#000';
  m.font = `800 ${fontSize}px "Arial Rounded MT Bold", Arial, sans-serif`;
  m.textAlign = 'center';
  m.textBaseline = 'middle';
  m.lineJoin = 'round';
  m.lineCap = 'round';
  m.lineWidth = Math.max(18, fontSize * (SCAD.contorno / SCAD.altezzaLettere) * 2.35);
  m.strokeStyle = '#000';
  m.strokeText(text, 0, -fontSize * .02);
  m.fillText(text, 0, -fontSize * .02);
  return { canvas:mc, x:-ox, y:-oy };
}
function maskFill(mask, fill){
  const out = document.createElement('canvas');
  out.width = mask.canvas.width;
  out.height = mask.canvas.height;
  const o = out.getContext('2d');
  o.drawImage(mask.canvas, 0, 0);
  o.globalCompositeOperation = 'source-in';
  if (typeof fill === 'function') o.fillStyle = fill(o, out.width, out.height);
  else o.fillStyle = fill;
  o.fillRect(0, 0, out.width, out.height);
  return out;
}
function fillMask(mask, color, dx, dy, alpha){
  const out = maskFill(mask, color);
  ctx.save();
  ctx.globalAlpha = alpha == null ? 1 : alpha;
  ctx.drawImage(out, mask.x + dx, mask.y + dy);
  ctx.restore();
}
function materialFill(mask, hex){
  return maskFill(mask, hex);
}
function drawMaterialTexture(mask){
  const tex = document.createElement('canvas');
  tex.width = mask.canvas.width;
  tex.height = mask.canvas.height;
  const t = tex.getContext('2d');
  t.drawImage(mask.canvas, 0, 0);
  t.globalCompositeOperation = 'source-in';
  t.translate(tex.width/2, tex.height/2);
  t.globalAlpha = .14;
  for (let i=-180;i<220;i+=10){
    t.strokeStyle = i % 20 === 0 ? 'rgba(255,255,255,.75)' : 'rgba(0,0,0,.32)';
    t.lineWidth = 1;
    t.beginPath();
    t.moveTo(mask.x, i);
    t.lineTo(-mask.x, i + 8);
    t.stroke();
  }
  ctx.drawImage(tex, mask.x, mask.y);
}
function darken(hex, amt){
  const h = hex.replace('#','');
  const full = h.length === 3 ? h.split('').map(c => c+c).join('') : h;
  const r = Math.max(0, Math.round(parseInt(full.slice(0,2),16) * (1 - amt)));
  const g = Math.max(0, Math.round(parseInt(full.slice(2,4),16) * (1 - amt)));
  const b = Math.max(0, Math.round(parseInt(full.slice(4,6),16) * (1 - amt)));
  return `rgb(${r},${g},${b})`;
}
function render(){
  ctx.clearRect(0,0,CW,CH);
  drawCoverImage();
  drawNamePlate();
}
function renderFallback(){
  ctx.fillStyle = '#cbc5ac';
  ctx.fillRect(0,0,CW,CH);
  ctx.save();
  ctx.translate(CW*.5, CH*.55);
  ctx.rotate(-47*Math.PI/180);
  ctx.fillStyle = '#172554';
  roundedRect(ctx, -CW*.55, -18, CW*1.1, 36, 18);
  ctx.fill();
  ctx.restore();
  drawNamePlate();
}
function renderColors(){
  const wrap = $('pmColors') || $('swatches');
  const label = $('pmColorLabel') || $('colorLabel');
  if (!wrap) return;
  wrap.innerHTML = '';
  COLORS.forEach(col => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'pm-swatch' + (state.colorMode === 'solid' && state.color.name === col.name ? ' active' : '');
    b.style.setProperty('--pm-swatch-bg', col.hex);
    b.style.setProperty('background', col.hex, 'important');
    b.style.setProperty('background-color', col.hex, 'important');
    b.title = col.name;
    b.onclick = function(){
      state.colorMode = 'solid';
      state.color = col;
      state.mix = null;
      renderColors();
      updatePrice();
      reloadPhoto();
      render();
    };
    wrap.appendChild(b);
  });
  MIXES.forEach(mix => {
    const b = document.createElement('button');
    b.type = 'button';
    const bg = quadrantBackground(mix.colors || []);
    b.className = 'pm-swatch pm-swatch--mix' + (isMixSelected() && state.mix.name === mix.name ? ' active' : '');
    b.style.setProperty('--pm-swatch-bg', bg);
    b.style.setProperty('background', bg, 'important');
    b.title = mix.name;
    b.setAttribute('aria-label', mix.name);
    b.onclick = function(){
      state.colorMode = 'mix';
      state.mix = mix;
      renderColors();
      updatePrice();
      reloadPhoto();
      render();
    };
    wrap.appendChild(b);
  });
  if (label) label.textContent = currentColorName();
}
function quadrantBackground(colors){
  const palette = colors.length ? colors : [{ hex:'#E889A9' }, { hex:'#8E5CF7' }];
  const c1 = palette[0] ? palette[0].hex : '#E889A9';
  const c2 = palette[1] ? palette[1].hex : c1;
  const c3 = palette[2] ? palette[2].hex : c1;
  const c4 = palette[3] ? palette[3].hex : c2;
  return `conic-gradient(${c2} 0 25%, ${c3} 0 50%, ${c4} 0 75%, ${c1} 0 100%)`;
}
function renderQuantities(){
  const wrap = $('pmQty') || $('qtyGrid');
  if (!wrap) return;
  wrap.innerHTML = '';
  QUANTITIES.forEach(q => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'pm-qty qty-btn' + (state.qty === q.id ? ' active' : '');
    b.innerHTML = `<strong>${q.label}</strong><span>${priceForQty(q.id)}</span>`;
    b.onclick = function(){
      state.qty = q.id;
      renderQuantities();
      updatePrice();
    };
    wrap.appendChild(b);
  });
}
function priceForQty(qty){
  const group = isMixSelected() ? PRICES.vibe : PRICES.regular;
  return (group && group[qty]) || '';
}
function updatePrice(){
  const total = $('pmTotal') || $('totalPrice');
  if (total) total.textContent = priceText();
  renderQuantities();
}
let galleryImages = [];
let lightboxIndex = 0;
function buildGallery(){
  const box = $('pmGallery');
  const grid = $('pmGalleryGrid');
  if (!box || !grid) return;
  grid.innerHTML = '';
  galleryImages = (CFG.gallery || []).slice(0, 12).map(item => {
    if (typeof item === 'string') return { thumb:item, full:item };
    return { thumb:item.thumb || item.full || '', full:item.full || item.thumb || '' };
  }).filter(item => item.thumb && item.full);
  if (!galleryImages.length){
    box.style.display = 'none';
    return;
  }
  box.style.display = 'flex';
  galleryImages.forEach((item, i) => {
    const img = document.createElement('img');
    img.loading = 'lazy';
    img.src = item.thumb;
    img.alt = 'Foto matite personalizzate';
    img.onclick = () => openLightbox(i);
    grid.appendChild(img);
  });
}
function openLightbox(i){
  if (!galleryImages.length) return;
  lightboxIndex = i;
  const lb = document.getElementById('pmLightbox');
  const img = document.getElementById('pmLbImg');
  if (!lb || !img) return;
  img.src = galleryImages[lightboxIndex].full;
  lb.classList.add('open');
  lb.setAttribute('aria-hidden','false');
  const multi = galleryImages.length > 1;
  const prev = document.getElementById('pmLbPrev');
  const next = document.getElementById('pmLbNext');
  if (prev) prev.style.display = multi ? 'flex' : 'none';
  if (next) next.style.display = multi ? 'flex' : 'none';
}
function closeLightbox(){
  const lb = document.getElementById('pmLightbox');
  if (!lb) return;
  lb.classList.remove('open');
  lb.setAttribute('aria-hidden','true');
}
function stepLightbox(delta){
  if (!galleryImages.length) return;
  lightboxIndex = (lightboxIndex + delta + galleryImages.length) % galleryImages.length;
  const img = document.getElementById('pmLbImg');
  if (img) img.src = galleryImages[lightboxIndex].full;
}
function initLightbox(){
  const lb = document.getElementById('pmLightbox');
  const close = document.getElementById('pmLbClose');
  const prev = document.getElementById('pmLbPrev');
  const next = document.getElementById('pmLbNext');
  if (close) close.onclick = closeLightbox;
  if (prev) prev.onclick = e => { e.stopPropagation(); stepLightbox(-1); };
  if (next) next.onclick = e => { e.stopPropagation(); stepLightbox(1); };
  if (lb) lb.addEventListener('click', e => { if (e.target === lb) closeLightbox(); });
  document.addEventListener('keydown', e => {
    if (!lb || !lb.classList.contains('open')) return;
    if (e.key === 'Escape') closeLightbox();
    else if (e.key === 'ArrowLeft') stepLightbox(-1);
    else if (e.key === 'ArrowRight') stepLightbox(1);
  });
}
function generatePreviewThumb(){
  try{
    const t = document.createElement('canvas');
    t.width = 300; t.height = 300;
    t.getContext('2d').drawImage(canvas, 0, 0, t.width, t.height);
    return t.toDataURL('image/jpeg', .76);
  }catch(e){ return null; }
}
function normalizedVariantValue(value){
  return String(value || '').trim().toLocaleLowerCase('it-IT');
}
function productVariantId(){
  const variants = Array.isArray(CFG.productVariants) ? CFG.productVariants : [];
  const color = normalizedVariantValue(currentColorName());
  const quantity = state.qty.replace('set', '');
  const match = variants.find(variant => {
    const values = Array.isArray(variant.options) ? variant.options : [variant.title];
    const normalized = values.map(normalizedVariantValue);
    const hasColor = normalized.includes(color);
    const hasQuantity = normalized.some(value => {
      const numbers = value.match(/\d+/g) || [];
      return numbers.includes(quantity);
    });
    return hasColor && hasQuantity;
  });
  return match ? match.id : null;
}
function variantId(){
  const liveId = productVariantId();
  if (liveId) return liveId;
  const map = CFG.variants || {};
  const key = currentColorName();
  return (map[state.qty] && map[state.qty][key]) || (map[state.qty] && map[state.qty].default) || null;
}
async function addToCart(){
  const name = formatName(state.name);
  if (!name){ showToast('Inserisci il nome prima di continuare'); return; }
  const btn = $('pmAdd') || $('addBtn');
  const drawer = document.querySelector('cart-drawer');
  const id = variantId();
  if (!id){
    showToast('Configura gli ID variante nello snippet Shopify');
    return;
  }
  const original = btn ? btn.textContent : '';
  if (btn){ btn.disabled = true; btn.textContent = 'Aggiunta in corso...'; }
  const props = {
    'Nome': name,
    'Colore': currentColorName(),
    'Quantità': state.qty === 'set24' ? 'Set da 24' : (state.qty === 'set12' ? 'Set da 12' : 'Set da 6')
  };
  if (isMixSelected()){
    props['Colori inclusi'] = (state.mix.colors || []).map(col => col.name).join(', ');
  }
  render();
  const thumb = generatePreviewThumb();
  if (thumb) props._preview = thumb;
  const cartPayload = { items:[{ id, quantity:1, properties:props }] };
  if (drawer && typeof drawer.getSectionsToRender === 'function'){
    cartPayload.sections = drawer.getSectionsToRender().map(section => section.id);
    cartPayload.sections_url = window.location.pathname;
    if (typeof drawer.setActiveElement === 'function' && btn){
      drawer.setActiveElement(btn);
    }
  }
  try{
    const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const res = await fetch(shopRoot + 'cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify(cartPayload)
    });
    if (!res.ok){ const e = await res.json(); throw new Error(e.description || 'Errore'); }
    const added = await res.json();
    if (drawer && added.sections && typeof drawer.renderContents === 'function'){
      const firstItem = Array.isArray(added.items) ? added.items[0] : null;
      drawer.renderContents(Object.assign({}, added, { id: firstItem ? firstItem.id : id }));
    }else{
      window.location.href = shopRoot + 'cart';
    }
  }catch(err){
    showToast(err.message);
  }finally{
    if (btn){ btn.disabled = false; btn.textContent = original; }
  }
}
let toastTimer = null;
function showToast(msg){
  let t = document.getElementById('pmToast');
  if (!t){
    t = document.createElement('div');
    t.id = 'pmToast';
    t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%) translateY(20px);background:#2a2a2a;color:#fff;padding:.8rem 1.2rem;border-radius:12px;font-size:.9rem;z-index:100000;opacity:0;transition:opacity .25s,transform .25s;pointer-events:none;box-shadow:0 8px 24px rgba(0,0,0,.3);';
    document.body.appendChild(t);
  }
  t.textContent = msg;
  t.style.opacity = '1';
  t.style.transform = 'translateX(-50%) translateY(0)';
  clearTimeout(toastTimer);
  toastTimer = setTimeout(function(){
    t.style.opacity = '0';
    t.style.transform = 'translateX(-50%) translateY(20px)';
  }, 2600);
}

const nameInput = $('pmName') || $('nameInput');
if (nameInput){
  nameInput.value = state.name;
  nameInput.addEventListener('input', function(){
    state.name = nameInput.value;
    render();
  });
}
const addBtn = $('pmAdd') || $('addBtn');
if (addBtn) addBtn.onclick = addToCart;
renderColors();
renderQuantities();
buildGallery();
initLightbox();
updatePrice();
render();
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();
})();
